import { useAuth } from "@x-veloper/dataslot-auth";

export function InvitationDebug() {
  const auth = useAuth();
  const { signInWithLine, handleLineCallback, getLineAuthError } = auth;

  console.log("=== INVITATION COMPONENT DEBUG ===", {
    hasSignInWithLine: !!signInWithLine,
    signInWithLineType: typeof signInWithLine,
    hasHandleLineCallback: !!handleLineCallback,
    hasGetLineAuthError: !!getLineAuthError,
    signInWithLineFunction: signInWithLine,
    allAuthKeys: Object.keys(auth),
    authObject: auth
  });

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      right: 0,
      background: 'yellow',
      padding: '10px',
      zIndex: 9999,
      fontSize: '12px'
    }}>
      <div>signInWithLine: {signInWithLine ? '✅ YES' : '❌ NO'}</div>
      <div>Type: {typeof signInWithLine}</div>
    </div>
  );
}
